module.exports = __webpack_public_path__ + "static/media/onboarding-resources.9994606d.png";